import RecommendationDetails from "./RecommendationDetails";
export default RecommendationDetails;
